import { __assign } from "tslib";
import React from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { Container, IconContainer, SVGContainer, } from './metric-icon.styles';
import { generateCircles } from './utils';
var SVG_DIMENSION = 450;
var createCircleMotion = function (opacity) { return ({
    hidden: {
        opacity: 0,
    },
    visible: {
        opacity: opacity,
    },
}); };
export var createCircleTransition = function (index) { return ({
    delay: 0.1 * index,
    duration: 0.1,
}); };
var MetricIcon = function (_a) {
    var children = _a.children, circleStyle = _a.circleStyle, position = _a.position, baseColor = _a.baseColor;
    var circles = generateCircles({ color: baseColor, circleStyle: circleStyle });
    var strokeProps = circleStyle === 'solid'
        ? {}
        : {
            strokeWidth: 2,
            stroke: baseColor,
        };
    return (React.createElement(Container, { position: position },
        React.createElement(IconContainer, null,
            children,
            React.createElement(SVGContainer, null,
                React.createElement("svg", { role: "img", preserveAspectRatio: "xMinYMin", width: SVG_DIMENSION, height: SVG_DIMENSION },
                    React.createElement(AnimatePresence, null, circles.map(function (_a, idx) {
                        var radius = _a.radius, color = _a.color, opacity = _a.opacity;
                        return (React.createElement(motion.circle, __assign({ key: idx, fill: color, r: radius }, strokeProps, { variants: createCircleMotion(opacity), transition: createCircleTransition(idx), exit: {}, initial: "hidden", animate: "visible", cx: "50%", cy: "50%" })));
                    })))))));
};
export default MetricIcon;
